module.exports = __webpack_public_path__ + "img/file-code-02.73b58884.svg";